/**
 * @file info-popup.ts
 * @module app/modules/_common/components/pop-up/info-popup
 * @description Utility for displaying an info popup.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { showPopup } from './popup-service';
import type { PopupOptions } from './popup-service';

const showInfoPopup = (options: PopupOptions | string = {}) =>
  showPopup('info', options);

export default showInfoPopup;